import { createRoute } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { AnalysisTemplatesAdmin } from "@/pages/admin/AnalysisTemplatesAdmin";
import { Route as RootRoute } from "./__root";

/**
 * /admin/analysis-templates (ADR-019 / TM-5743cb35) — admin-only CRUD
 * шаблонов запросов для анализа менеджеров. Гейтится через
 * `analysis_template_edit`.
 */
export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/admin/analysis-templates",
  component: () => (
    <RoleGuard action="analysis_template_edit">
      <AnalysisTemplatesAdmin />
    </RoleGuard>
  ),
});
